import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ClockIcon } from 'lucide-react';
export function UrgencySection() {
  return <section className="py-8 md:py-20 bg-amber text-charcoal-dark" data-id="element-346">
      <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-347">
        <FadeIn data-id="element-348">
          <div className="flex justify-center mb-6" data-id="element-349">
            <ClockIcon className="w-12 h-12 text-charcoal-dark/80" data-id="element-350" />
          </div>
          <h2 className="text-2xl md:text-3xl font-heading font-bold mb-6" data-id="element-351">
            Atención Directa y Limitada
          </h2>
          <div className="space-y-4 text-lg font-medium text-charcoal-dark/90" data-id="element-352">
            <p data-id="element-353">Acompaño personalmente por WhatsApp durante los 7 días.</p>
            <p data-id="element-354">
              Eso requiere mi atención directa. Por eso trabajo con un número
              limitado de personas por semana.
            </p>
            <p className="text-2xl font-bold text-charcoal-dark mt-6" data-id="element-355">
              Si estás leyendo esto, hay lugar.
            </p>
            <p className="text-sm uppercase tracking-widest opacity-70 mt-2" data-id="element-356">
              No garantizo que lo haya mañana.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}